import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import html2canvas from "html2canvas";

const RankCardModalDownload = (props) => {
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  const brandingDetails = JSON.parse(localStorage.getItem("branding"));
  const modalContentRef = useRef(null);
  const captureImage = useCallback(() => {
    // const modalContent = document.getElementById("playermoreinfo");
    const targetElement = modalContentRef.current;

    if (modalContentRef.current) {
      html2canvas(targetElement, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-Top 10 Ranks`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  }, []);

  const handleModalEntered = useCallback(() => {
    const timeout = setTimeout(() => {
      captureImage();
      props.handleRankModalClose();
    }, 2000);
    return () => clearTimeout(timeout); // Cleanup the timeout
  }, [captureImage]);

  return (
    <Modal
      show={props.showRankModal}
      onHide={props.handleRankModalClose}
      size="lg"
      id="playermoreinfo"
      onEntered={handleModalEntered}
    >
      <div ref={modalContentRef}>
        <div className="player_star_info">
          <div className="player_star_pic">
            <Link
              className="player_profile_url"
              onClick={(e) => e.preventDefault()}
            >
              <figure className="player_profile_url">
                {clubDetails && (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${clubDetails?.logo}`}
                    alt="img"
                  />
                )}
                {!clubDetails && (
                  <img src={`../images/club-logo.png`} alt="img" />
                )}
              </figure>
            </Link>
            <div className="player_description">
              {/* <h3 className="breakWord">{clubDetails?.game_name}</h3> */}
              <h3 className="breakWord">Rankings</h3>
              <div className="player_game_name">{clubDetails?.game_name}</div>
              <div className="player_game_name">
                Type:
                {props.roundNumber ? (
                  <> Round {props.roundNumber}</>
                ) : (
                  " Overall "
                )}{" "}
              </div>

              <div className="player_game_name">
                Gameviews: {props.gameInfoBlockData?.gameViews}
              </div>
            </div>
          </div>
          <div className="club_logo">
            <figure>
              {!props.playerSponsorLogo && brandingDetails && (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}branding/${brandingDetails.logo}`}
                  alt="img"
                />
              )}
              {!brandingDetails && (
                <img src={`../images/small-brand-logo.jpg`} alt="img" />
              )}
            </figure>
          </div>
        </div>

        <div className="player-performance1">
          <ul>
            {props.topTenRank.length > 0 &&
              props.topTenRank
                .filter((playerData1) => !playerData1.userData)
                .map((item, key) => (
                  <li key={key}>
                    <div className="performancebox1">
                      <div className="playerprofilerank">
                        {item?.team_rank}
                        <figure>
                          {item?.userdata?.image && (
                            <img
                              src={`${process.env.REACT_APP_USER_PROFILE}/${item?.userdata?.image}`}
                              alt="img"
                            />
                          )}
                          {!item?.userdata?.image && (
                            <img src={`../images/user-img.png`} alt="img" />
                          )}
                        </figure>
                        {item?.userdata?.full_name}
                      </div>
                      <strong> {item?.team_points}</strong>
                    </div>
                  </li>
                ))}
          </ul>
        </div>
      </div>
      <Modal.Footer>
        <div className="poweredby">
          Powered By
          <img src="images/logo.png" alt="img" />
        </div>
        <div className="">
          {/* <Link
            to={`/player-profile/${props.playerInfoData.id}`}
            className="border-btn"
          >
            <i className="fas fa-user"></i>
          </Link> */}
          <Link
            onClick={captureImage}
            className="border-btn"
            style={{ textDecorationNo: "none", color: "black" }}
          >
            <i className="fas fa-download"></i>
          </Link>
          <Link className="border-btn" onClick={props.handleRankModalClose}>
            <i className="fas fa-times"></i>
          </Link>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RankCardModalDownload;
